import styled, {css} from 'styled-components'
import {Link} from "react-router-dom";

export const NavItem = styled.span<{accent?: boolean}>`
  font-family: ${({theme}) => theme.font.secondaryFont};
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
  text-transform: uppercase;
  cursor: pointer;
  border-radius: 25px;
  //padding: 9px 11px;
  transition: background-color 400ms linear;

  color: ${({ theme }) => theme.colors.navFont};

  &:hover {
    background: ${({theme}) => theme.colors.navFontBackHover};
    color: ${({theme}) => theme.colors.navFontHover};
  }
  
  ${({accent = false}) => accent
    ?
    css`
        color: rgba(179, 55, 108, 1);
        &:hover {
          background: #FFFFFF66;
          color: #000000;
        }
      `
    : null
  };
  
  & svg {
    & path {
      fill: ${({theme}) => theme.business.colors.textColor};
    }
  }

  //& > svg {
  //  &:last-child {
  //    margin-left: 1rem;
  //  }
  //}
`

export const NavItemMobile = styled.div`
  display: flex;
  cursor: pointer;
  &:hover {
    color: black;

    & svg {
      & path {
        fill: black;
      }
    }
  }

  & svg {
    & path {
      fill: ${({theme}) => theme.business.colors.textColor};
    }
  }

  @media only screen and (${({theme}) => theme.media.small}) {
    display: none;
  }
`

export const NavItemMobileIcon = styled(NavItemMobile)`
  color: ${({theme}) => theme.business.colors.textColor};
`

export const NavBar = styled.div`
  position: sticky;
  z-index: 200;
  top: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 60px;
  padding: 0 20px;
  overflow: hidden;
  font-size: 20px;

  background: ${({theme}) => theme.business.colors.navBackground};

  @media only screen and (${({theme}) => theme.media.extraLarge}) {
    padding: 0 100px;
    height: 70px;
  }
  
  @media only screen and (${({theme}) => theme.media.ultraLarge}) {
    padding: 0 200px;
    height: 80px;
  }
`

export const NavLogo = styled(Link)`
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.colors.navFont};
  gap: 5px;

  & svg {
    #text path {
      fill: ${({theme}) => theme.business.colors.textColor};
    }
  }
`

export const NavMenu = styled.div`
  font-size: 16px;
  display: none;
  justify-content: space-between;
  gap: 1rem;

  & a {
    color: ${({ theme }) => theme.colors.navFont};
  }
  
  & span {
    padding: 9px 11px;
  }

  @media only screen and (${({theme}) => theme.media.small}) {
    display: flex;
  }
`

export const NavRight = styled.div`
  display: none;
  justify-content: space-between;
  gap: 40px;

  color: ${({ theme }) => theme.colors.navFont};
  
  & span {
    display: flex;
    align-items: center;
  }

  @media only screen and (${({theme}) => theme.media.small}) {
    display: flex;
  }
`

export const NavRightButton = styled.div`
  display: flex;
  align-items: center;
  color: ${({theme}) => theme.business.colors.primary};
  padding: 0 20px 0 20px;
  border-radius: 40px;
  ${({theme}) => css`border: 1px solid ${theme.business.colors.primary}`};
  text-transform: uppercase;
  cursor: pointer;
  font-size: 16px;
  font-weight: 500;
  
  &:hover {
    background-color: ${({theme}) => theme.business.colors.primary};
    color: #FFF;
  }
`

export const NavRightItems = styled.div`
  display: flex;
  gap: 10px;
`

export const MobileMenuBack = styled.div`
  background-color: ${({theme}) => theme.business.colors.primary};
`

export const SvgWrapper = styled.div`
  & svg {
    & path {
      fill: ${({theme}) => theme.business.colors.textColor};
    }
  }
`